var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drone",class:{show: _vm.show}},[_c('Navbar',{ref:"navbar",staticClass:"navdrone"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }